export default __webpack_public_path__ + "static/media/stateHero.b0e5ed33.svg";